export default "__VITE_ASSET__BWLZEBFa__"